<script>
import { getDimensionUnits } from '@/graphql/mediakit/queries.graphql';

import { QueryHelper } from '@/components/Core/Helpers';

export default {
  name: 'DimensionUnitsQuery',

  mixins: [QueryHelper],

  query() {
    return {
      query: getDimensionUnits,
      variables: {
        supplier_id: this.$store.getters['auth/supplierId']
      }
    };
  }
};
</script>
